<template>
  <div>
    <!-- eslint-disable-next-line prettier/prettier -->
    <v-data-table
      v-bind="dataTableOptions"
      :items="items"
      hide-default-header
      item-key="id"
      class="elevation-0 content"
    >
      <template #header="{ props }">
        <thead class="v-data-table-header">
          <tr>
            <th v-for="(header, index) in props.headers" :key="index" :class="classes.header.th">
              <v-tooltip v-if="headerEllipsis" top>
                <template #activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" :class="classes.header.text">{{ header.text }}</div>
                </template>
                <span class="tooltip">{{ header.text }}</span>
              </v-tooltip>
              <span v-else class="singleline">{{ header.text }}</span>
            </th>
          </tr>
        </thead>
      </template>
      <template #item="{ item, headers }">
        <tr :class="{ 'v-data-table__selected': item.isSelected }" @click="onClickRow($event, item)">
          <td v-for="(header, index) in headers" :key="index" :class="getItemTdClasses(header.align)">
            <v-tooltip v-if="itemEllipsis" top>
              <template #activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" :class="this.classes.item.text">{{ converter(item[header.value], header.converter) }}</div>
              </template>
              <span class="tooltip">{{ item[header.value] }}</span>
            </v-tooltip>
            <span v-else class="singleline">{{ converter(item[header.value], header.converter) }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { merge } from 'lodash';

export default {
  // VDataTable options
  props: {
    headers: Array,
    items: Array,
    height: [Number, String],
    fixedHeader: Boolean,
    dense: Boolean,
    disablePagination: Boolean,
    hideDefaultFooter: Boolean,
    singleSelect: Boolean,
    clickRow: Function,

    // SingleLineHeaderDataTable options
    headerEllipsis: {
      type: Boolean,
      default: true,
    },
    itemEllipsis: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      classes: {
        header: {
          th: {
            'content-max-width': this.headerEllipsis,
          },
          text: {
            ellipsis: this.headerEllipsis,
          },
        },
        item: {
          td: {
            'content-max-width': this.itemEllipsis,
          },
          text: {
            ellipsis: this.itemEllipsis,
          },
        },
      },
    };
  },
  methods: {
    getItemTdClasses(align) {
      const textAlign = `text-${align || 'start'}`;
      return merge({}, this.classes.item.td, { [textAlign]: true });
    },
    converter(value, name) {
      const converter = {
        name,
        argument: undefined,
      };
      if (Array.isArray(name)) {
        converter.name = name[0];
        converter.argument = name[1];
      }
      return converter.name ? (this.$options.filters[converter.name] ? this.$options.filters[converter.name](value, converter.argument) : value) : value;
    },
    onClickRow(event, item) {
      const vm = this;
      this.$emit('click:row', item, {
        headers: this.headers,
        isSelected: item.isSelected,
        select(value) {
          vm.$set(item, 'isSelected', value);
          if (value) {
            const selectedIndex = vm.items.indexOf(item);
            vm.items.forEach((n, index) => {
              if (index !== selectedIndex) {
                if (n.isSelected) {
                  n.isSelected = false;
                  return false;
                }
              }
            });
          }
        },
      });
    },
  },
  computed: {
    dataTableOptions() {
      const options = merge({}, this.$props);
      delete options.items;
      return options;
    },
  },
};
</script>

<style scoped>
.content-max-width {
  max-width: 150px;
}
.singleline {
  white-space: nowrap !important;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tooltip {
  font-size: 11px;
}
</style>
